import React from "react";
import "./Chat.css";
function Loading() {
  return (
    <div>
      <span class="loader"></span>
    </div>
  );
}

export default Loading;
